function request<T>(onMessage: T) {
	return {
		url: `/websocket/connect`,
		onMessage,
		contentType: 'application/json',
		transport: 'websocket'
	};
}

export default request;
